import VideoCard from "@/components/VideoCard";
import { Sparkles } from "lucide-react";

const JOURNEYS = [
  {
    title: "Mistik See",
    vimeoId: "789994299",
    duration: "22 minuti",
    description:
      "Il lago mistico. Un viaggio nelle profondità dell'acqua per purificare le emozioni e ritrovare la chiarezza interiore.",
    accent: "#1535a0",
    badge: "Gratuito",
    testid: "viaggi-card-mistik-see",
  },
  {
    title: "Kalunet",
    vimeoId: "789990959",
    duration: "28 minuti",
    description:
      "La pipa sacra. Un viaggio nella foresta ancestrale per ricevere insegnamenti dagli spiriti della natura.",
    accent: "#2e9020",
    badge: "Gratuito",
    testid: "viaggi-card-kalunet",
  },
];

export default function Viaggi() {
  return (
    <div className="px-6 pt-10" data-testid="viaggi-screen">
      <header className="mb-7">
        <p className="font-body text-[11px] tracking-[0.4em] uppercase text-[#2e9020]">
          Viaggi P.O.T.
        </p>
        <h1 className="font-serif-display text-[36px] leading-[1.05] tracking-tight text-[#2e2820] mt-2">
          Percorsi Onirici <span className="italic">Terapeutici</span>
        </h1>
        <p className="font-body text-base text-[#7a6f65] leading-relaxed mt-3">
          Questi viaggi sciamanici ti portano in uno stato di coscienza espansa
          per esplorare, guarire e trasformare.
        </p>
      </header>

      <section className="flex flex-col gap-5">
        {JOURNEYS.map((j) => (
          <VideoCard key={j.vimeoId} {...j} />
        ))}
      </section>

      <aside
        data-testid="viaggi-advanced-note"
        className="mt-8 bg-[#f9f5ef] rounded-[18px] p-5 border border-[#ede7df] flex gap-3 items-start"
      >
        <Sparkles strokeWidth={1.5} className="w-5 h-5 text-[#941a7c] mt-0.5 shrink-0" />
        <p className="font-body text-sm text-[#7a6f65] leading-relaxed">
          <span className="font-medium text-[#2e2820]">Canketonon, Taytakura</span> e
          altri percorsi avanzati sono disponibili per i membri della community.
        </p>
      </aside>
    </div>
  );
}
